import { Link, useHistory } from "react-router-dom";
import React, { Fragment, useContext, useEffect, useState } from "react";
import axios from "axios";
import UserDataContext from "../../context/UserDataContext";
import { Dialog, Transition } from "@headlessui/react";

export default function Projects() {
  const token = localStorage.getItem("token");
  const { userData } = useContext(UserDataContext);
  const [addProjectPopup, setAddProjectPopup] = useState(false);
  const [recordData, setRecordData] = useState([]);
  const [newProjectName, setNewProjectName] = useState("");
  const history = useHistory();

  async function getData() {
    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/projects`,
      {
        headers: {
          jwttoken: token,
        },
      },
    );

    setRecordData(userRes.data);
  }

  const updateProject = async (project) => {
    try {
      const translations = await axios.get(
        `${process.env.REACT_APP_BACKEND}/settings/projects/${project.id}`,
        {
          headers: {
            jwttoken: token,
          },
        },
      );
      localStorage.setItem("currentProjectID", project.id);
      localStorage.setItem("currentProjectName", project.name);
      localStorage.setItem(
        "translations",
        JSON.stringify(
          translations.data[0].translations
            ? translations.data[0].translations
            : {},
        ),
      );
      history.push("/");
    } catch (err) {
      console.log(err);
    }
  };

  async function addProject(e) {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/settings/projects/new`,
        { bezeichnung: newProjectName, owner: userData.id },
        {
          headers: {
            jwttoken: token,
          },
        },
      );
      setAddProjectPopup(false);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg text-center flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Projektauswahl
          </h3>
        </div>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="container flex justify-start w-full">
          <div className="flex flex-col grow">
            <div className="border-b border-gray-200  overflow-hidden sm:rounded-lg">
              <div className="py-12 bg-white">
                <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="grid grid-cols-6 gap-6 text-center">
                    {recordData &&
                      recordData.map((project) => {
                        if (
                          userData.projekte.includes(project._id) ||
                          userData.permissions.isAdmin
                        ) {
                          return (
                            <Link
                              to="#"
                              onClick={() =>
                                updateProject({
                                  id: project._id,
                                  name: project.bezeichnung,
                                })
                              }
                              className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
                            >
                              {project.bezeichnung}
                            </Link>
                          );
                        }
                      })}
                    {userData && userData.permissions.isAdmin && (
                      <Link
                        to="#"
                        onClick={() => {
                          setAddProjectPopup(true);
                        }}
                        className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-green-600 hover:bg-green-700"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="size-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
                          />
                        </svg>{" "}
                        Projekt hinzufügen
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {addProjectPopup && (
              <Transition.Root show={addProjectPopup} as={Fragment}>
                <Dialog
                  as="div"
                  className="relative z-10"
                  onClose={setAddProjectPopup}
                >
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                  </Transition.Child>

                  <div className="fixed z-10 inset-0 overflow-y-auto">
                    <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      >
                        <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <Dialog.Title
                                  as="h3"
                                  className="text-lg leading-6 font-medium text-gray-900"
                                >
                                  Neues Projekt hinzufügen
                                </Dialog.Title>
                                <div className="mt-5">
                                  <form onSubmit={addProject}>
                                    <input
                                      placeholder="Projekt Bezeichnung"
                                      type="string"
                                      onChange={(e) =>
                                        setNewProjectName(e.target.value)
                                      }
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                    />
                                    <button
                                      type="submit"
                                      className="mt-5 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Speichern
                                    </button>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition.Root>
            )}
          </div>
        </div>
      </div>
      {userData && userData.permissions.isAdmin && (
        <>
          <div className="bg-white shadow overflow-hidden sm:rounded-lg text-center flex justify-between">
            <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                App-Einstellungen (gilt für alle Projekte)
              </h3>
            </div>
          </div>
          <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center my-5">
            <div className="container flex justify-start w-full">
              <div className="flex flex-col grow">
                <div className="border-b border-gray-200  overflow-hidden sm:rounded-lg">
                  <div className="py-12 bg-white">
                    <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
                      <Link
                        to="users"
                        className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
                      >
                        Benutzerverwaltung
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
